import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from '@alltrails/shared/denali/components/Typography';
import * as styles from './styles/styles.module.scss';
import OnePercentForThePlanet from './OnePercentForThePlanet';
import LeaveNoTrace from './LeaveNoTrace';

const MembersForThePlanet = () => (
  <div className={styles.container}>
    <div className={styles.title}>
      <Typography component="h2" variant="text300bold" color="inverse">
        <FormattedMessage defaultMessage="Members for the planet" />
      </Typography>
    </div>
    <div className={styles.membersIconsContainer}>
      <OnePercentForThePlanet className={styles.logo} />
      <LeaveNoTrace className={styles.logo} />
    </div>
  </div>
);

export default MembersForThePlanet;
